import Color from "color";

type ColorParam = ConstructorParameters<typeof Color>[0];

export const lightenColor = (color: ColorParam, percent: number) => {
  return Color(color)
    .lighten(percent - 1)
    .hex()
    .toString();
};

export const saturateColor = (hex: ColorParam, percent: number) => {
  return Color(hex)
    .blacken(percent - 1)
    .hex()
    .toString();
};
